export const findMaxChapterCount = (phase: any) => {
    const subjects = phase.subjects;
    let maxChapterCount = 0;
    for (const subject of subjects) {
      if (subject.chapterCount > maxChapterCount) {
        maxChapterCount = subject.chapterCount;
      }
    }
    return maxChapterCount;
  }